const HomePage = {
  path: "/home",
  name: "xihuHomePage",
  meta: {
    noCheckLogin: true
  },
  component: () => import("@/pages/xihu/homePage")
};
const SingleCalendar = {
  path: "/singleCalendar",
  name: "xihuSingleCalendar",
  meta: {
    noCheckLogin: true
  },
  component: () => import("@/pages/xihu/calendar")
}
const Ticket = {
  path: "/ticketlist",
  name: "xihuTicketlist",
  meta: {
    noCheckLogin: true
  },
  component: () => import("@/pages/ticket/ticketlist")
};
const Shop = {
  path: "/shoplist",
  name: "xihuShoplist",
  meta: {
    noCheckLogin: true
  },
  component: () => import("@/pages/shop/shoplist")
};
const Overview = {
  path: "/overview",
  name: "xihuOverview",
  meta: {
    noCheckLogin: true
  },
  component: () => import("@/pages/xihu/overview")
};
const ActiveDetaill = {
  path: "/activeDetail",
  name: "xihuActiveDetaill",
  meta: {
    noCheckLogin: true
  },
  component: () => import("@/pages/xihu/activeDetail")
};
const CommonDetaill = {
  path: "/commonDetail",
  name: "xihuCommonDetaill",
  meta: {
    noCheckLogin: true
  },
  component: () => import("@/pages/xihu/commonDetail")
};
const Introduction = {
  path: "introduction",
  name: "xihuOverviewIntroduction",
  meta: {
    noCheckLogin: true
  },
  component: () => import("@/pages/xihu/overview/introduction")
};
const History = {
  path: "history",
  name: "xihuOverviewHistory",
  meta: {
    noCheckLogin: true
  },
  component: () => import("@/pages/xihu/overview/history")
};
const Legend = {
  path: "legend",
  name: "xihuOverviewLegend",
  meta: {
    noCheckLogin: true
  },
  component: () => import("@/pages/xihu/overview/legend")
};
const Map = {
  path: "map",
  name: "xihuOverviewMap",
  meta: {
    noCheckLogin: true
  },
  component: () => import("@/pages/xihu/overview/map")
};
const Relic = {
  path: "relic",
  name: "xihuOverviewRelic",
  meta: {
    noCheckLogin: true
  },
  component: () => import("@/pages/xihu/overview/relic")
};
const Scenic = {
  path: "scenic",
  name: "xihuOverviewScenic",
  meta: {
    noCheckLogin: true
  },
  component: () => import("@/pages/xihu/overview/scenic")
};
const ScenicDetail = {
  path: "scenicDetail",
  name: "xihuOverviewScenicDetail",
  meta: {
    noCheckLogin: true
  },
  component: () => import("@/pages/xihu/overview/scenicDetail")
};
Overview.children = [
  Introduction,
  History,
  Legend,
  Map,
  Relic,
  Scenic,
  ScenicDetail
];

const xihuRouter = [
  HomePage,
  Overview,
  Ticket,
  Shop,
  ActiveDetaill,
  CommonDetaill,
  SingleCalendar
];

export default xihuRouter;



// WEBPACK FOOTER //
// ./src/router/xihu.js